export const enrollmentStatusMap = {
    PENDING: 'pending',
    CANCELLED: 'cancel',
    TERMINATED: 'term',
    CONFIRMED: 'confirm',
    'ORDER CONFIRMED': 'orderConfirm',
    'PAYMENT RECEIVED': 'paymentReceivied',
    ENROLLED: 'enrolled',
};

export enum EnrollmentIdType {
    HEALTH = 'healthEnrollmentId',
    DENTAL = 'dentalEnrollmentId',
}
